import { render, staticRenderFns } from "./WorkAreas.vue?vue&type=template&id=3d246954"
import script from "./WorkAreas.vue?vue&type=script&lang=js"
export * from "./WorkAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports